import { createFileRoute, retainSearchParams } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { ProductCostsTabsLayout } from "@/screens/Products/components/Product/Costs"

export const PRODUCT_COSTS_LAYOUT_ROUTE_PATH = "/app/product/$productId/edit/_layout/costs/_layout"

export const Route = createFileRoute(PRODUCT_COSTS_LAYOUT_ROUTE_PATH)({
  search: {
    middlewares: [retainSearchParams([])],
  },
  component: () => (
    <PermissionContentWrapper
      permissions={[
        PermissionActionType.COST_MAINTENANCE,
        PermissionActionType.VENDOR_MAINTENANCE,
        PermissionActionType.VENDOR_VIEW,
      ]}
    >
      <ProductCostsTabsLayout />
    </PermissionContentWrapper>
  ),
})
